import React from 'react';
import ReportAccountContextProvider from 'contexts/report/ReportAccountContext';
import reportLocales from 'globals/locales/report';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import AccountFiltersSection from './AccountFiltersSection';
import AccountDetailsSection from './AccountDetailsSection';
import AccountChartsSection from './AccountChartsSection';
import AccountTransactionsSection from './AccountTransactionsSection';

// Locales
const { title } = reportLocales.account;

const ReportAccount: React.FC = () => {
  return (
    <FsPaper title={title}>
      <ReportAccountContextProvider>
        <AccountFiltersSection />
        <AccountDetailsSection />
        <AccountChartsSection />
        <AccountTransactionsSection />
        {/* <AccountAdditionalInformationSection /> */}
      </ReportAccountContextProvider>
    </FsPaper>
  );
};

export default ReportAccount;
